import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approved-drawing',
  templateUrl: './approved-drawing.component.html',
  styleUrls: ['./approved-drawing.component.css']
})
export class ApprovedDrawingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/approved-drawing/approved-drawing.component.ts